import {
  FileDto,
  FileUploadLinkResponse,
  TemporaryLinkResponse,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const filesRequests = {
  getSignedUrl: EndpointDefinition.get<TemporaryLinkResponse, { id: string }>({
    name: 'getSignedUrl',
    route: '/files/:id/temporary-link',
  }),

  getFileInfo: EndpointDefinition.get<FileDto, { id: string }>({
    name: 'getFileInfo',
    route: '/files/:id',
  }),

  getFileUploadLink: EndpointDefinition.post<
    FileUploadLinkResponse,
    { fileName: string; mimeType: string; size: number },
    null
  >({
    name: 'getFileUploadLink',
    route: '/files/presigned-url',
  }),

  cleanUpErroneousFile: EndpointDefinition.post<
    FileUploadLinkResponse,
    null,
    { id: string }
  >({
    name: 'cleanUpErroneousFile',
    route: '/files/:id/cleanup',
  }),

  uploadVoicemail: EndpointDefinition.post<
    FileDto,
    {
      file: File;
    },
    null
  >({
    name: 'uploadVoicemail',
    route: '/files/upload-voicemail',
  }),
};
